import React, { useRef, useState } from "react";
import { BsFillDice5Fill } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import check from "../../assets/images/check.png";
import Backdrop from "../UIElements/Backdrop";
import CheckBox from "../UIElements/Checkbox";

const ShopFilters = ({
  color,
  size,
  categoryList,
  handleCategoryChange,
  handleSizeChange,
  handleColorChange,
  selectedCategory,
  selectedSize,
  selectedColor,
}) => {
  const mainmenuRef = useRef(null);

  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [checked, setChecked] = useState([]);

  const showHideFilter = () => {
    mainmenuRef.current.classList.toggle("active");
    setDrawerIsOpen(true);
  };

  const HideFilter = () => {
    mainmenuRef.current.classList.toggle("active");
    setDrawerIsOpen(false);
  };

  const closeDrawerHandler = () => {
    showHideFilter();
    setDrawerIsOpen(false);
  };

  // console.log(categoryList, 'cat list')

  return (
    <>
      <div className="shop-filter-toggle" onClick={() => showHideFilter()}>
        <BsFillDice5Fill className="filter-toggle-icon" />
      </div>
      <div className="filter-select" ref={mainmenuRef}>
        <div className="shop-filters">
          {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}

          <div className="main-heading">
            <h2>
              Filter Products by{" "}
              <span onClick={HideFilter}>
                <FaTimes className="close-shop-sidebar" />
              </span>
            </h2>
          </div>

          <div className="all-filters">
            <div className="filters-column category">
              <h3 className="column-title">Category</h3>
              <div className="category-flex">
                {categoryList.map((category) => (
                  <>
                    <label className="custom-checkbox" key={category._id}>
                      <input
                        type="checkbox"
                        checked={selectedCategory.includes(category._id)}
                        onChange={() => handleCategoryChange(category._id)}
                      />
                      <span className="custom-checkbox__checkmark">
                        <img
                          src={check}
                          alt="checkbox-check"
                          className="img-fluid"
                        />
                      </span>
                      {category.categoryname}
                    </label>
                  </>
                ))}
              </div>
            </div>
            <div className="filters-column color">
              <h3 className="column-title">Color</h3>
              <div className="color-flex">
                {color.map((c) => (
                  <>
                    <input
                      type="checkbox"
                      value={c.color}
                      key={c.color}
                      id={c.display}
                      className="color-check-input"
                      checked={selectedColor.includes(c.color)}
                      onChange={(e) => handleColorChange(c.color)}
                    />
                    <label
                      htmlFor={c.display}
                      className="color-label"
                      style={{ backgroundColor: c.display }}
                    ></label>
                  </>
                ))}
              </div>
            </div>

            <div className="filters-column size">
              <h3 className="column-title">Size</h3>
              {size.map((size) => (
                // <CheckBox label={item.display} key={index} />
                <label className="custom-checkbox" key={size.size}>
                  <input
                    type="checkbox"
                    value={size.size}
                    checked={selectedSize.includes(size.size.toUpperCase())}
                    onChange={() => handleSizeChange(size.size.toUpperCase())}
                  />
                  <span className="custom-checkbox__checkmark">
                    <img
                      src={check}
                      alt="checkbox-check"
                      className="img-fluid"
                    />
                  </span>
                  {size.display}
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopFilters;
